import { render, staticRenderFns } from "./ShenqingShouhou.vue?vue&type=template&id=1da151e0&scoped=true"
import script from "./ShenqingShouhou.vue?vue&type=script&lang=js"
export * from "./ShenqingShouhou.vue?vue&type=script&lang=js"
import style0 from "./ShenqingShouhou.vue?vue&type=style&index=0&id=1da151e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da151e0",
  null
  
)

export default component.exports